import { Injectable } from '@angular/core';
import { RolesEnum, Routes } from '../utils/routes';
import { environment } from '../../../environments/environment';
import { OidcSecurityService } from 'angular-auth-oidc-client';

@Injectable( {
  providedIn: 'root'
} )
export class AuthService {
  roles = [];

  constructor( private oidcSecurityService: OidcSecurityService ) {
  }

  getRoles(): any[] {
    this.oidcSecurityService.getIdToken().subscribe( token => {
      if( token ) {
        const payload = JSON.parse( atob( token.split( '.' )[1] ) );
        this.roles = payload['cognito:groups'] || payload['role'];
      }
    } );

    return this.roles;
  }

  logout() {
    this.oidcSecurityService.logoff( '', {
      customParams: {
        authority: environment.Authority_URL,
        redirect_uri: window.location.origin,
        client_id: environment.Client_ID,
        scope: 'email openid',
        response_type: 'code'
      }
    } ).subscribe();
  }

  routeEnabledModule(): string {
    if( this.roles.includes( RolesEnum.AdminRole ) || this.roles.includes( RolesEnum.EditorRole ) || this.roles.includes(
      RolesEnum.ViewerRole ) ) {
      return Routes.BookingOverview;
    }
    else if( this.roles.includes( RolesEnum.AdminRole ) || this.roles.includes( RolesEnum.EditorRole ) ) {
      return Routes.RevenueManager;
    }
    else if( this.roles.includes( RolesEnum.AdminRole ) || this.roles.includes( RolesEnum.EditorRole ) ) {
      return Routes.AutoConfirm;
    }
    else if( this.roles.includes( RolesEnum.SuperAdminRole ) ) {
      return Routes.AdminSettings;
    }
    else if( this.roles.includes( RolesEnum.AdminRole ) ) {
      return Routes.Settings;
    }
    else {
      return Routes.PageNotFound;
    }
  }
}
